import { render, staticRenderFns } from "./OnAirMessage.vue?vue&type=template&id=6f1117f0"
import script from "./OnAirMessage.vue?vue&type=script&lang=js"
export * from "./OnAirMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports